import type { Project, ProjectScript } from "../../types";
import { usePrimaryEnvironmentId } from "../../environments/primary/context";
import { useServerAvailableEditors, useServerKeybindings } from "../../rpc/serverState";
import { OpenInPicker } from "./OpenInPicker";
import ProjectScriptsControl from "../ProjectScriptsControl";
import { createThreadProjectScriptActions } from "./threadProjectScriptActions";

export function ThreadProjectActions(props: {
  readonly project: Project;
  readonly cwd: string | null;
  readonly onRunScript: (script: ProjectScript) => Promise<void>;
}) {
  const primaryId = usePrimaryEnvironmentId();
  const editors = useServerAvailableEditors();
  const keybindings = useServerKeybindings();
  const scripts = createThreadProjectScriptActions(props.project);
  return (
    <>
      <ProjectScriptsControl
        scripts={props.project.scripts}
        keybindings={keybindings}
        onRunScript={(script) => {
          void props.onRunScript(script);
        }}
        onAddScript={scripts.add}
        onUpdateScript={scripts.update}
        onDeleteScript={scripts.remove}
      />
      {props.project.environmentId === primaryId && editors.length > 0 ? (
        <OpenInPicker keybindings={keybindings} availableEditors={editors} openInCwd={props.cwd} />
      ) : null}
    </>
  );
}
